import React, {useEffect, useState, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link, Redirect, useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";
import { debounce } from '../../utils/debounce';

function DetailPlaces() {
    
    const data = useLocation()
    let updatePlaceState = data.state["update"]

    const history = useHistory()  
    const [palabrasClave, setPalabrasClave] = useState([])
    const [listErrors, setListErrors] = useState([])
    const [petSpecies, setPetSpecies] = useState([])
    const [petBreed, setPetBreed] = useState([])
    const [directionsInPlace, setDirectionsInPlace] = useState( updatePlaceState ? data.state["place"]["directionsInPlace"] : [])

    const [code, setCode] = useState(updatePlaceState ? data.state["place"]["code"] : "");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [palabra, setPalabra] = useState("")
    const [btnMessage, setBtnMessage] = useState("Subir sitio");

    const [countryInfo, setCountryInfo] = useState({})
    const [user, setUser] = useState({})
    const [day, setDay] = useState({})

    const [chargedEventFromState, setChargedEventFromState] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [sidebarStatus, setSidebarStatus] = useState(false)

    const inputTag = useRef(null)
    const inputSku = useRef(null)
    const inputName = useRef(null)
    const inputDesc = useRef(null)
    const inputWord = useRef(null)
    const inputPeso = useRef(null)
    const inputPrice = useRef(null)
    const inputCantidad = useRef(null)
    const inputMinima = useRef(null)
    const hiddenFileInput = useRef(null);
    
    let errorInputMsg = "Campo requerido"

    let listCategories = [
        "Aseguradora",
        "Asociación Veterinaria",
        "Clínica",
        "Congreso o Expo",
        "Estética",
        "Estética Móvil",
        "Fabricante de Accesorios o Ropa",
        "Fabricante de Alimentos o Medicamentos",
        "Funeraria",
        "Guardería u Hotel (estancia corta)",
        "Laboratorio",
        "Médico",
        "ONG – Refugio, Casa Hogar o Albergue",
        "Otros lugares Pet Friendly"
    ]

    const [directionObject, setDirectionObject] = useState({
        directionObject: "",
        hourFrom: "",
        hourTo: "",
    })

    const [place, setPlace] = useState({
        subjectId: "",
        title: "",
        categorie: "",
        description: "",
        status: "",
        directionsInPlace: [],
        media: [
            {
                url: "",
                type: "photo",
                index: 0
            }
        ],
        tags: palabrasClave,
        code: code
    })

    const [selectedListOfGroups, setSelectedListOfGroups] = useState([])

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');

    const [changeNumber, setChangeNumber] = useState(0);
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
  
    const handleScroll = debounce(() => {
      const currentScrollPos = window.pageYOffset;
  
      setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70) || currentScrollPos < 10);
  
      setPrevScrollPos(currentScrollPos);
    }, 100);
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => window.removeEventListener('scroll', handleScroll);
  
    }, [prevScrollPos, visible, handleScroll]);
  
    const navbarStyles = {
      position: 'fixed',
      height: '65px',
      width: '83.3%',
      backgroundColor: 'white',
      zIndex: "11",
      textAlign: 'center',
      transition: 'top 0.6s',
      padding: "1% 2%",
      right: "0px",
      boxShadow: "0 0.125rem 0.625rem rgb(90 97 105 / 12%)"
    }

    const handleClick = place => {
        hiddenFileInput.current.click();
    };

    async function handleChange(e) {
        var file = e.target.files[0]
        Compress.imageFileResizer(
          file,
          600,
          300,
          "JPEG",
          10,
          0,
          (uri) => {
            setFile(uri)
            console.log(uri)
          },
          "file",
          600,
          300
        )
        setImg(URL.createObjectURL(file))
        setListErrors(listErrors.filter( prev => prev !== "img" ))
    }

    const handleKeyPress = (place) => {
        if(place.key === 'Enter' && palabra !== ""){
            setPalabrasClave([...palabrasClave, palabra])
            inputTag.current.value = ""
        }
    }
      
    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    async function manageTypePetSpecie(type){
        let list = []
        setPlace({...place, features: {...place["features"], species: type}})
        await firebase.db.collection("Especies").doc(type).collection("Razas").get().then((v)=>{
          v.docs.forEach(doc=>{
            list.push(doc.id)
            list.sort()
          })
          setPetBreed(list)
        })
    }

    function checkInputs(){
        let val = 0
        let array = []

        let o = {
            img: data.state["update"] ? place.media[0]["url"] : src,
            title: place["title"],
            categorie: place["categorie"],
            status: place["status"]
        }

        Object.keys(o).forEach(function(key) {
            if (o[key] === '' || o[key] === undefined) {
                val++
                array.push(key)
            }
        });
        if(val > 0){
            setListErrors(array)
            setError(true)
            setSuccess(false)
            window.scrollTo(0, 0)
        }else{
            setError(false)
            setSuccess(true)
            setListErrors([])
            if(data.state["update"]){
                setSuccessMsg("Sitio editado exitosamente")
                updatePlace()
            }else{
                setSuccessMsg("Sitio creado exitosamente")
                createPlace()
            }
            console.log("Todo bien")
        }
    }

    function manageAddedGroup(g){
        let list = [...selectedListOfGroups]

        if(selectedListOfGroups.includes(g)){
            list = list.filter((prv)=> prv !== g ) 
        }else{
            list.push(g)
        }

        setSelectedListOfGroups(list)
    }

    function updateRoleInPlace(key, newValue, object){
        let list = [...directionsInPlace]

        let findedIndex = list.findIndex((prv)=> prv["direction"] === object["direction"])

        list[findedIndex][key] = newValue
        
        setDirectionsInPlace(list)
    }

    function removeRoleToPlace(prop){
        let list = [...directionsInPlace]

        setDirectionsInPlace(list.filter((prv)=> prv["direction"] !== prop["direction"]))
    }

    function addRoleToPlace(){
        let list = [...directionsInPlace]
        
        let exists = list.find((prv)=> prv["direction"] === directionObject["direction"])

        if(directionObject.direction !== "" && !exists){
            list.push(directionObject)
        }
        setDirectionsInPlace(list)
    }

    function makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
       }
       return result;
    }
    
    const RoleComponent = ({r}) => {
        return (
            <div className={`creation-input-group no-gutters mb-2`}>
                <div className="col-lg-auto mr-2">
                    <input type="text" defaultValue={r["direction"]} onChange={(e)=>{ updateRoleInPlace("direction", e.target.value, r) }} className="form-control"/>
                </div>
                <div className="col-lg-auto mr-2">
                    <input type="time" defaultValue={r["hourFrom"]} onChange={(e)=>{updateRoleInPlace("hourFrom", e.target.value, r)}} className="form-control"/>
                </div>
                <div className="col-lg-auto mr-2">
                    <input type="time" defaultValue={r["hourTo"]} onChange={(e)=>{updateRoleInPlace("hourTo", e.target.value, r)}} className="form-control"/>
                </div>
                <div className="col-lg-auto">
                    <div onClick={()=>{ removeRoleToPlace(r) }} className="btn-circular btn-circular-danger mr-3"><span className="material-icons">delete</span></div>
                </div>
            </div>
        )
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
        });
    }, [])
  
    useEffect(() => {
        if(data.state["update"]){
            setPlace({
                ...data.state["place"]
            })
            setCode(data.state["place"]["code"])
        }else{
            setCode(makeid(6))
        }
        setChargedEventFromState(true)
    }, [chargedEventFromState])

    return (
        <div className="main-content-container container-fluid px-4">
            
            {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
            {success && <SuccessComponent msg={successMsg === "" ? "Evento editado exitosamente" : successMsg}/>}

            <div style={{ ...navbarStyles, top: visible ? '-60px' : '60px' }}>
                <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                    <h4 className="color-primary bold mb-0">{updatePlaceState ? "Editar" : "Nuevo"}</h4>
                    {
                        updatePlaceState ?
                            <div className="row no-gutters">
                                <div onClick={()=>{ checkInputs() }}  className="btn btn-success mr-3">Actualizar sitio</div>
                                <div onClick={()=>{ deletePlace() }} className="btn btn-danger mr-3">Eliminar sitio</div>
                                <div onClick={()=>{updateActive()}} className={`btn ${place.status === "Activo" ? "btn-outline-danger" : "btn-outline-success"}`}>{place.status === "Activo" ? "Desactivar" : "Activar"} <span className="d-none">{changeNumber}</span> </div>
                            </div> 
                        : 
                            <div className="row no-gutters">
                                <div onClick={()=>{ checkInputs() }}  className="btn btn-success mr-3">Crear sitio</div>
                            </div> 
                    }
                </div>
            </div>

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="page-title bold"><Link className="color-white mr-3 light" to="/configuration">Configuración</Link> <Link className="color-white light" to="/configuration/place">Sitios pet friendly</Link> <span>Detalle</span> </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-1 mb-0 level-1">
                    <div className="row align-items-center justify-content-space-around level-2">
                        <i onClick={()=>{}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                    </div>
                </div>
            </div>

            <div className="row no-gutters">
                <div className="col-lg-8">
                    
                    <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                        <h4 className="color-primary bold mb-0">{updatePlaceState ? "Editar" : "Nuevo"}</h4>
                        {
                            updatePlaceState ?
                                <div className="row no-gutters">
                                    <div onClick={()=>{ checkInputs() }}  className="btn btn-success mr-3">Actualizar sitio</div>
                                    <div onClick={()=>{ deletePlace() }} className="btn btn-danger mr-3">Eliminar sitio</div>
                                    <div onClick={()=>{updateActive()}} className={`btn ${place.status === "Activo" ? "btn-outline-danger" : "btn-outline-success"}`}>{place.status === "Activo" ? "Desactivar" : "Activar"} <span className="d-none">{changeNumber}</span> </div>
                                </div> 
                            : 
                                <div className="row no-gutters">
                                    <div onClick={()=>{ checkInputs() }}  className="btn btn-success mr-3">Crear sitio</div>
                                </div> 
                        }
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title">Detalles adicionales</div>
                        <div className="creation-card-content">
                            
                            { !updatePlaceState && <div className="creation-input-group mr-4 no-gutters">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Estado del sitio</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={place.status} onChange={(e)=>{setPlace({...place, status: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "status" ) )  }} 
                                    className={`form-control col-lg-12 ${ listErrors.includes("status") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="active">Activo</option>
                                        <option value="draft">Borrador</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("status") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>}

                            <div className={`creation-input-group no-gutters mr-4`}>
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Código</p>
                                </div>
                                <div className="col-lg-auto">
                                    <input type="text" value={code} disabled={true} placeholder="Ayuda" className="form-control"/>
                                </div>
                            </div> 

                            <div className={`creation-input-group no-gutters mr-4 ${ palabrasClave.length > 3 && "mb-4" }`}>
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Etiquetas</p>
                                </div>
                                <div className="col-lg-auto">
                                    <input ref={inputTag} type="text" onKeyPress={handleKeyPress} onChange={e=>{setPalabra(e.target.value)}}  placeholder="Ayuda" className="form-control"/>
                                </div>
                            </div> 

                            <div className="creation-input-group-words">
                                {palabrasClave.map(p => (
                                    <p className="pill mb-0" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                                ))}
                            </div>

                        </div>
                    </div>
                    
                    <div className="creation-card mb-3">
                        <div className={`creation-input-group no-gutters mr-4`} style={{width: "20%"}}>
                            <div className="col-lg-auto mr-2">
                                <div className="creation-card-title">Localidades</div>
                            </div>
                        </div> 
                        <div className="creation-card-content">
                            <div className="creation-input-group no-gutters mr-4 mb-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">-</p>
                                    <input type="text" placeholder="Nombre, zona, ciudad, otro" onChange={(e)=>{setDirectionObject({...directionObject, direction: e.target.value});}} className="form-control"/>
                                </div>
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Horario desde</p>
                                    <input type="time" onChange={(e)=>{setDirectionObject({...directionObject, hourFrom: e.target.value});}} className="form-control"/>
                                </div>
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Horario hasta</p>
                                    <input type="time" onChange={(e)=>{setDirectionObject({...directionObject, hourTo: e.target.value});}} className="form-control"/>
                                </div>
                                <div className="col-lg-auto">
                                    <div onClick={()=>{ 
                                        addRoleToPlace()
                                    }} className="btn btn-primary">Agregar</div>
                                </div>
                            </div>
                            
                            {directionsInPlace !== undefined && directionsInPlace.map((r)=> <RoleComponent r={r} />  )}

                        </div>
                    </div>
                    
                </div>
                <div className="col-lg-4 pl-4">
                    
                    <div className="creation-card mb-5 p-3">
                        <div className="creation-card-content">
                            <div className="position-relative"  style={{width: "100%"}}>
                                <input type="file" ref={hiddenFileInput} onChange={handleChange}  style={{display: 'none'}} />
                                <div onClick={handleClick} className={`creation-input-photo ${ listErrors.includes("img") && "border-danger" }`}>
                                    {src !== "" ? <img src={src} alt="" /> : (
                                        data.state["update"] ? 
                                            <img src={place.media[0]["url"]} alt="" /> 
                                        :  <div className="card-header-img-upload"><p className="material-icons icon">add</p><p className="mb-0">Cargar imagen</p></div>
                                    )}
                                </div>
                                <div style={{textAlign: "center", width: "100%"}}>
                                    <p style={{fontSize: "13px", color: "#a3a6af"}} className="my-3">Dimensiones recomendadas (200px x 300px)</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Categoría</p>
                                </div>
                                <select onChange={(e)=>{setPlace({...place, categorie: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "categorie" ) )  }}
                                value={place.categorie} type="text" className={`form-control col-lg-12 ${ listErrors.includes("categorie") && "border-danger" } `}>
                                    <option value="">Seleccionar</option>
                                    {listCategories.map((cat)=> <option value={cat}>{cat}</option> )}
                                </select>
                            </div>

                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Nombre del sitio</p>
                                </div>
                                <input onChange={(e)=>{setPlace({...place, title: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "title" ) )  }} 
                                value={place.title} ype="text" className={`form-control col-lg-12 ${ listErrors.includes("title") && "border-danger" } `} />
                            </div>
                            

                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Acerca del sitio</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={place.description} onChange={(e)=>{setPlace({...place, description: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "description" ) )  }} 
                                    placeholder="Descripción del sitio" className={`form-control col-lg-12 ${ listErrors.includes("description") && "border-danger" } `}/>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("descripcion") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

    async function updateActive(){
        try{
          await firebase.db.collection('Places').doc(place.placeId).update({
            status: place.status === "Activo" ? "Borrador" : "Activo"
          })
          place.status = place.status === "Activo" ? "Borrador" : "Activo"
          setTimeout(() => {
            setChangeNumber( changeNumber + 1 )
          }, 100);
        }catch(e){
          console.log(`Error: ${e}`)
        }
    }

    async function deletePlace(){
        await firebase.db.collection('Places').doc(place.placeId).delete()
        window.location.href = "/configuration/place"
    }
    
    async function updatePlace(){

        if(file){
            await firebase.storage.ref(`/Place imagenes/${file.name}`).put(file)
            await firebase.storage.ref("Place imagenes").child(file.name).getDownloadURL().then(async (url)=>{
                
                place["media"][0]["url"] = url
                await firebase.db.collection('Places').doc(place.placeId).update({...place, roles: directionsInPlace})
    
            })
        }else{
            await firebase.db.collection('Places').doc(place.placeId).update({...place, roles: directionsInPlace})
        }

        window.location.href = "/configuration/place"
    }
    
    async function createPlace(){
        let id = firebase.db.collection('Places').doc().id
        place["subjectId"] = "A" + user.aliadoId
        
        await firebase.storage.ref(`/Place imagenes/${file.name}`).put(file)
        await firebase.storage.ref("Place imagenes").child(file.name).getDownloadURL().then(async (url)=>{
            
            place["media"][0]["url"] = url

            await firebase.db.collection('Places').doc(id).set({
                ...place,
                code: code,
                placeId: id,
                directionsInPlace: directionsInPlace
            })
            directionsInPlace.forEach(async (pl, i) => {
                if(i === 0){
                    var localidadId = firebase.db.collection("Localidades").doc().id
                    await firebase.db.collection("Localidades").doc(localidadId).set({
                        aliadoId: code,
                        serviciosContiene: false,
                        localidadId: localidadId,
                        nombreLocalidad: place.title,
                        locacionImg: url,
                        ciudad: pl["directionObject"],
                        pais: user.pais,
                        lc: "Localidad Principal",
                        direccionDetallada: pl["directionObject"],
                        direccionLocalidad: pl["directionObject"],
                        telefono: "",
                        otroTelefono: "",
                        createdOn: moment().toDate(),
                        hourFrom: pl["hourFrom"],
                        hourTo: pl["hourTo"]
                    })
                }else{
                    var localidadId = firebase.db.collection("Localidades").doc().id
                    await firebase.db.collection("Localidades").doc(localidadId).set({
                        aliadoId: code,
                        serviciosContiene: false,
                        localidadId: localidadId,
                        nombreLocalidad: place.title,
                        locacionImg: url,
                        ciudad: pl["directionObject"],
                        pais: user.pais,
                        direccionDetallada: pl["directionObject"],
                        direccionLocalidad: pl["directionObject"],
                        telefono: "",
                        otroTelefono: "",
                        createdOn: moment().toDate(),
                        hourFrom: pl["hourFrom"],
                        hourTo: pl["hourTo"]
                    })
                }
            })

        })

        window.location.href = "/configuration/place"
    }

}

export default DetailPlaces